import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Publications from '../components/Publications';
import { useSelector } from 'react-redux';

const PublicationsPage = () => {
	const isPageLoading = useSelector((state) => state.pages.isLoading)
	return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
		<Publications />
	)
}

export default PublicationsPage